export default "__VITE_ASSET__BJoYqsEp__"